import React, { Component } from 'react';
import PropTypes from 'prop-types';
import countries from '../../../data/countries.json';
import { lowercaseHyphen } from '../../../utils/stringConversion';
import SelectInput from './SelectInput';
import FlagIcon from '../Icons/FlagIcon';
import Label from './Label';

class CountryPhoneCodeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countriesFormattedForInput: [],
      iconCode: 'world',
    };
  }

  componentDidMount() {
    this.formatCountriesForInput();
    if (this.props.value) {
      this.changeIcon(this.props.value);
    }
  }

  componentWillReceiveProps(nextProps) {
    // For some reason this doesn't get called on initial render so have to have the same function in componentDidMount
    if (this.props.value !== nextProps.value) {
      this.changeIcon(nextProps.value);
    }
  }

  formatCountriesForInput = () => {
    const countriesFormattedForInput = [];
    Object.keys(countries).forEach((key) => {
      const option = countries[key];
      const label = `${option.dial_code} (${option.name})`;
      countriesFormattedForInput[key] = { value: option.code, label };
    });

    this.setState({ countriesFormattedForInput });
  }

  handleChange = (e) => {
    const countryCode = e.target.value;
    const selectedCountry = countries.find(country => country.code === countryCode);
    this.props.onChange(e, selectedCountry.dial_code);
    this.changeIcon(selectedCountry.code);
  }

  changeIcon = (iconName) => {
    const iconCode = lowercaseHyphen(iconName);
    this.setState({ iconCode });
  }

  render() {
    const { name, label, value, error, touched, children, required, classes } = this.props;
    const { countriesFormattedForInput, iconCode } = this.state;

    return (
      <div className={`country-phone-code-input form-group ${classes}`}>
        <Label name={name} required={required}>{label}</Label>

        {children}

        <div className="country-phone-code-input__inner position-relative">
          <SelectInput
            name="areaCode1"
            value={value}
            onChange={this.handleChange}
            defaultOption="Code"
            options={countriesFormattedForInput}
            error={error}
            touched={touched}
          />

          <FlagIcon name={iconCode} />
        </div>
      </div>
    );
  }
}

CountryPhoneCodeInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  required: PropTypes.bool,
  classes: PropTypes.string,
};

export default CountryPhoneCodeInput;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/CountryPhoneCodeInput.js